import { createDomain } from 'effector-root';

const domain = createDomain('Assembly List (Page)');

export const onPageStarted = domain.event();